// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../services/build-number';

const NumberOfRecordsFound = props =>
    <div className='help-text'>
        <FormattedMessage
            id='RECORDS_FOUND'
            values={{
                count: props.count,
                countToDisplay: buildNumber(props.count)
            }}
        />
    </div>;

NumberOfRecordsFound.displayName = 'NumberOfRecordsFound';
NumberOfRecordsFound.propTypes = {
    count: PropTypes.number.isRequired
};

export default NumberOfRecordsFound;



// WEBPACK FOOTER //
// ./src/shared/components/number-of-records-found/index.js